var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1454_9786)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.624,
    cy: 13.5117,
    r: 3.75,
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2759 14.2617C18.6738 13.5727 19.329 13.0699 20.0976 12.8639C20.8661 12.658 21.685 12.7658 22.374 13.1636C23.0631 13.5615 23.5659 14.2167 23.7718 14.9853C23.9777 15.7538 23.8699 16.5727 23.4721 17.2617C23.0743 17.9508 22.419 18.4536 21.6505 18.6595C20.8819 18.8654 20.0631 18.7576 19.374 18.3598C18.685 17.962 18.1822 17.3067 17.9762 16.5382C17.7703 15.7696 17.8781 14.9508 18.2759 14.2617L18.2759 14.2617Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.374 28.5117H5.874V30.0117H19.374V28.5117ZM5.25655 27.8903C5.45128 26.6693 5.91954 24.9339 7.0199 23.5183C8.09298 22.1378 9.80203 21.0117 12.624 21.0117V19.5117C9.3256 19.5117 7.18453 20.8623 5.8356 22.5977C4.51397 24.298 3.98836 26.3179 3.77527 27.6541L5.25655 27.8903ZM12.624 21.0117C15.446 21.0117 17.155 22.1378 18.2281 23.5183C19.3285 24.9339 19.7967 26.6693 19.9914 27.8903L21.4727 27.6541C21.2596 26.3179 20.734 24.298 19.4124 22.5977C18.0635 20.8623 15.9224 19.5117 12.624 19.5117V21.0117ZM5.874 28.5117C5.43637 28.5117 5.20942 28.1858 5.25655 27.8903L3.77527 27.6541C3.56145 28.9948 4.65477 30.0117 5.874 30.0117V28.5117ZM19.374 30.0117C20.5932 30.0117 21.6865 28.9948 21.4727 27.6541L19.9914 27.8903C20.0386 28.1858 19.8116 28.5117 19.374 28.5117V30.0117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5698 27.6361L25.8423 27.8183L25.8423 27.8183L26.5698 27.6361ZM18.3255 22.4829L17.9236 21.8496L17.1509 22.34L17.7836 23.0013L18.3255 22.4829ZM20.7331 27.7722L19.9925 27.8903L20.7331 27.7722ZM25.2175 28.5117H19.375V30.0117H25.2175V28.5117ZM25.8423 27.8183C25.923 28.1406 25.6863 28.5117 25.2175 28.5117V30.0117C26.5236 30.0117 27.6478 28.8533 27.2974 27.4539L25.8423 27.8183ZM20.875 22.5117C22.4166 22.5117 23.4993 23.2657 24.2925 24.3221C25.1016 25.3997 25.5767 26.7576 25.8423 27.8183L27.2974 27.4539C27.0106 26.309 26.4743 24.7297 25.492 23.4215C24.4939 22.0921 23.0053 21.0117 20.875 21.0117V22.5117ZM18.7274 23.1161C19.3121 22.745 20.0142 22.5117 20.875 22.5117V21.0117C19.723 21.0117 18.7431 21.3296 17.9236 21.8496L18.7274 23.1161ZM17.7836 23.0013C19.2045 24.4867 19.7721 26.5086 19.9925 27.8903L21.4737 27.6541C21.2346 26.1544 20.5986 23.774 18.8674 21.9644L17.7836 23.0013ZM19.9925 27.8903C20.0396 28.1858 19.8126 28.5117 19.375 28.5117V30.0117C20.5942 30.0117 21.6876 28.9948 21.4737 27.6541L19.9925 27.8903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.999,
    y: 9.38672,
    width: 6.75,
    height: 0.75,
    rx: 0.375,
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.749,
    y: 6.38672,
    width: 6.75,
    height: 0.75,
    rx: 0.375,
    transform: "rotate(90 28.749 6.38672)",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1454_9786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCount);
export default __webpack_public_path__ + "static/media/usersCount.5dc5d2b393c040c4dd766fe7fef36c12.svg";
export { ForwardRef as ReactComponent };